export default __webpack_public_path__ + "static/media/CadillacFavicon.74e142fb.svg";